import React from 'react';
import { Link, useLocation } from 'react-router-dom';
/*ui*/
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
/*component*/
import Typography from "@material-ui/core/Typography";
import { appStyle } from "../theme/appStyle";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import { getWishlistData, WL } from "../helpers/localStorage";
import _get from "lodash/get";
import LazyImage from "./LazyImage";
import getSuppotedFileType from "../helpers/getSuppotedFileType";
import { PAGES_SLUGS } from "../constants";
import listingCardGeneralStyles from "../theme/listingCardGeneralStyles";
import DetailsCarPrice from "./ContentBlocks/Cars/DetailsCarPrice";
import toLocale from '../helpers/toLocale';

const useStyles = makeStyles((theme) => ({
    ...appStyle(theme),
    ...listingCardGeneralStyles(theme),
    imageContainer: {
        position: 'relative',
    },
    chipRow: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(1),
        right: theme.spacing(1),
        zIndex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    sku: {
        color: theme.palette.colorDarkGrey,
        fontSize: '12px',
        fontWeight: 400,
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: 1,
    },
    chipBase: {
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: 400,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    chipEcobonus: {
        ...appStyle(theme).chipBase,
        fontSize: '13px',
        fontWeight: 400,
        background: "#52A30A",
        color: "#141414",
        textTransform: 'none',
    },
    chipReserved: {
        ...appStyle(theme).chipBase,
        fontSize: '13px',
        fontWeight: 400,
        background: "#F8D200",
        color: "#141414",
        textTransform: 'none',
    },
    technicalDataDescription: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        flex:"1 auto",
    },
    detailsContainer: {
        padding: theme.spacing(2),
    },
    carName: {
        marginBottom: theme.spacing(1),
        height: '48px',
        display: 'flex',
        alignItems: 'center',
    },
    usedCarCard: {
        backgroundColor: theme.palette.grey[200]
    }
}));

function DetailedCarCard(props) {
    const classes = useStyles();
    const location = useLocation();
    const carData = props.data;
    const isUsedCar = carData.car_type === 'UsedCar';
    const gridItemSize = isUsedCar ? 3 : 4;

    return (
        <Card elevation={0} className={`${classes.carCard} ${isUsedCar ? classes.usedCarCard : ''}`}>
            <Link to={{ pathname: `/${PAGES_SLUGS.DETAILS}/${carData.slug}`, state: { from: location.pathname } }} className={classes.linkDecoration}>
                <div className={classes.imageContainer}>
                    <Box position='relative'>
                        <LazyImage
                            src={getSuppotedFileType(_get(carData, "media[0].thumb", []))}
                            ratio={56}
                            isAnimated={true}
                            alt={carData.name}
                        />
                        {getWishlistData(WL.CAR).includes(carData.slug) &&
                            <div className={classes.wishlistHeart}>
                                <Icon className={`${classes.wlIcon} brand-icon-heart-fill`} />
                            </div>
                        }
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} className={classes.chipRow}>
                            <Box>
                                {_get(carData, "rom_ref", false) &&
                                    <Typography component={"div"} className={classes.sku}># {carData.rom_ref}</Typography>}

                            </Box>
                            <Box display={"flex"} marginRight={2}>
                                {_get(carData, "rezervat", false) &&
                                    <div className={`${classes.chipBase} ${classes.chipReserved}`}>Rezervat</div>
                                }
                                {(_get(carData, "ecobonus", false) || _get(carData, "ecobonus_bev", false)) &&
                                    <div className={`${classes.chipBase} ${classes.chipEcobonus}`}>Eco Bonus</div>
                                }
                            </Box>
                        </Box>
                    </Box>
                </div>
                <Box display={"flex"} flexDirection={"column"} flexGrow={1} className={classes.detailsContainer}>
                    <Typography className={`${classes.carName} ${classes.weight500}`}>
                        {_get(carData, "short_name", "")}
                    </Typography>
                    <Divider />
                    <Grid container spacing={1} className={classes.technicalDataDescription}>
                        <Grid item xs={3} container
                            direction="column"
                            alignItems="center">
                            <span className={"brand-icon-medium brand-icon-fuel"}> </span>
                            <Typography variant={"caption"} align={"center"}>{carData.fuel}</Typography>
                        </Grid>
                        {!isUsedCar && (
                            <Grid item xs={gridItemSize} container
                                direction="column"
                                alignItems="center">
                                <span className={"brand-icon-medium brand-icon-transmission"}> </span>
                                <Typography variant={"caption"} align={"center"}>
                                    {carData.transmission_type && carData.transmission_type.length > 14
                                        ? carData.transmission_type.substring(0, 14)
                                        : carData.transmission_type
                                    }
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={gridItemSize} container
                            direction="column"
                            alignItems="center">
                            <span className={"brand-icon-medium brand-icon-traction"}> </span>
                            <Typography variant={"caption"} align={"center"}>
                                {carData.transmission && carData.transmission.length > 14
                                    ? carData.transmission.substring(0, 14)
                                    : carData.transmission}
                            </Typography>
                        </Grid>

                        {isUsedCar && (
                            <>
                                <Grid item xs={gridItemSize} container
                                    direction="column"
                                    alignItems="center">
                                    <span className={"brand-icon-medium brand-icon-speed"}> </span>
                                    <Typography variant={"caption"} align={"center"}>
                                        {toLocale(carData.km_purchase_date)}km
                                    </Typography>
                                </Grid>
                                <Grid item xs={gridItemSize} container
                                    direction="column"
                                    alignItems="center">
                                    <span className={"brand-icon-medium brand-icon-factory"}> </span>
                                    <Typography variant={"caption"} align={"center"}>{carData.manufacturing_year}</Typography>
                                </Grid>
                            </>
                        )}
                    </Grid>
                    <Divider />
                    <Box display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        pt={1}
                    >
                        <Typography variant={'h5'} color={"primary"} className={classes.weight300}>
                            {DetailsCarPrice(carData)}
                        </Typography>
                        <Typography variant={'caption'} color={"primary"} className={classes.weight300}>
                            <span className={"brand-icon-right-nav-arrow"}> </span>
                        </Typography>
                    </Box>
                </Box>
            </Link>
        </Card>
    );
}

export default DetailedCarCard;
